module.exports = __webpack_public_path__ + "media/brands/daf-e315a18d.png";